// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ComplianceServiceRequest } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Compliance';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useComplianceServiceRequests: () => UseQueryResult<
  TemplateContract<ComplianceServiceRequest>[],
  string
> = () =>
  useOperatorBasedQuery('queryComplianceServiceRequests', (ledgerApi, offset, operator) =>
    ledgerApi.queryComplianceServiceRequests(offset, operator),
  );

export default useComplianceServiceRequests;
